// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingConditionPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module ConditionalFormattingConditionPopup popup component
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import connect from 'share/enhancers/Izenda.Connect';
import constants from 'logic/data/Izenda.ConditionalFormattingConstants';
import { getOr } from 'lodash/fp';
import Condition from './Izenda.ConditionalFormattingCondition';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import DropDown from 'share/components/controls/Izenda.DropDown';
import ConditionalFormattingAdditionalConditionsPopup from './Izenda.ConditionalFormattingAdditionalConditionsPopup';
import ConditionType from './Izenda.ConditionalFormattingConditionType';
import ConditionValue from './Izenda.ConditionalFormattingConditionValue';

const {GRID_STYLES, FIELD_CONTAINER_TYPES} = constants;

@observer
class ConditionalFormattingConditionPopup extends Component {
  condition = null;
  gridProperties = null;
  fields = [];

  constructor(props) {
    super(props);

    this.setGridProperties();
    this.setFields();
    this.setCondition();
  }

  setGridProperties = () => {
    const {props: {gridProperties}} = this;
    this.gridProperties = gridProperties;
  }

  setFields = () => {
    const {props: {fields}} = this;
    this.fields = fields;
  }

  setCondition = () => {
    const {props: {condition}} = this;
    this.condition = new Condition(condition);
  }

  renderFieldRow = () => {
    const {condition, fields: {simpleFields}, props: {localization}} = this;

    const onFieldChange = (newField) => {
      condition.setField(newField);
    };

    return (
      <GridLayout.Row>
        <GridLayout.Col className="u_controlHeight" cols={3}>{localization.getText('CONDITIONAL_FORMATTING_LABEL_CONDITION_FIELD')}</GridLayout.Col>
        <GridLayout.Col cols={9}>
          <DropDown value={condition.conditionField.name} onChange={onFieldChange} options={simpleFields} valueField="name" labelField="name" additionalValueField="value"/>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }

  renderAdditionalLinkRow = () => {
    const {props: {localization, openPopup}, condition, fields, gridProperties: {gridStyle}} = this;
    const containerType = getOr('', 'conditionField.containerType', condition);

    if(gridStyle !== GRID_STYLES.PIVOT || containerType !== FIELD_CONTAINER_TYPES.VALUE)
      return null;

    const onAdditionalConditionsChange = (additionalConditions) => {
      condition.additionalConditions = additionalConditions;
    }

    const onLinkClick = () => {
      openPopup(ConditionalFormattingAdditionalConditionsPopup, { 
        additionalConditions: condition.additionalConditions,
        additionalFields: fields.additionalFields,
        onAdditionalConditionsChange: onAdditionalConditionsChange
      });
    }

    return (
      <GridLayout.Row>
        <GridLayout.Col className="u_textRight">
          <a onClick={onLinkClick}><span className="u_textUnderline">{localization.getText('CONDITIONAL_FORMATTING_LABEL_MORE')}</span></a>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }

  render() {
    const {
      props: {localization, onReject, onAccept, onConditionChange},
      condition, renderFieldRow, renderAdditionalLinkRow
    } = this;

    const onClosing = (callback, type) => {
      if(type === 'accept'){
        const conditionData = condition.serializeData();
        onConditionChange(conditionData);
        onAccept();
      }else{
        onReject();
      }
    };

    return (
      <Popup visible onClosing={onClosing} autoClose={false} type="none" sizeClass="modal-sm">
        <Popup.Header title={localization.getText('CONDITIONAL_FORMATTING_CONDITION_POPUP_TITLE')} />
        <Popup.Body>
            <div className="izenda-ConditionalFormattingCondititon">
              <GridLayout>
                {renderFieldRow()}
                {renderAdditionalLinkRow()}
                <ConditionType condition={condition} localization={localization} />
                <ConditionValue condition={condition} localization={localization} />
              </GridLayout>
            </div>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type="cancel">
            {localization.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

const popupWindow = connect()(ConditionalFormattingConditionPopup);
popupWindow.displayName  = 'ConditionalFormattingConditionPopup';
export default popupWindow;


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingConditionPopup.jsx